import { Divider } from '@zenterprise-inc/ui';
import { useEffect } from 'react';

import JointCertificateSection from './JointCertificateSection';
import SimpleAuthSection from './SimpleAuthSection';

import { initResultRefundData } from '@/components/tax-refund/common/data/result-refund-data';

const ResultSelectAuthContent = () => {
  useEffect(() => {
    initResultRefundData();
  }, []);

  return (
    <>
      <SimpleAuthSection />
      <div className="mt-6" />
      <Divider.Section />
      <div className="mt-4" />
      <JointCertificateSection />
    </>
  );
};

export default ResultSelectAuthContent;
